import React from 'react'
import SectionCollapse from '../../../../../section/SectionCollapse'
import DataGrid from '../../../../../table/DataGrid'

const GrowthGoals = ({ growthGoals = [] }) => (
  <SectionCollapse title='Growth Goals'>
    <div className='relative h-screen-1/5'>
      <DataGrid
        id='growth-goals'
        showSetting={false}
        rows={growthGoals?.map((row, index) => {
          return {
            ...row,
            index: index + 1,
          }
        })}
        rowsPerPage={growthGoals?.length || 0}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 20, show: true, hide: false },
          { label: 'Question', key: 'question', show: true, hide: false },
        ]}
        labelNoRows="You don't have any question yet"
      />
    </div>
  </SectionCollapse>
)

export default GrowthGoals